import { getGetSubscriptionTemplatesMockHandler } from "@vega-api/generated/subscription-templates-templates/subscription-templates-templates.msw";
import type { TemplateListResponse } from "@vega-api/generated/types/templateListResponse";

/**
 * Custom mock handler for getting user profile that returns a user with ID that can be used for assignment.
 * This ensures the assignee dropdown and "Assign to Me" functionality work correctly.
 */
export const getSubscriptionTemplatesHandler = () => {
  // Create a consistent mock response with a user that can be assigned to cases
  const customProfileResponse: TemplateListResponse = {
    errors: null,
    data: [
      {
        id: "39faa07d-6f1c-4f3f-91c1-7f38549e702b",
        name: "Fund X template",
        isPublished: true,
        createdAt: "2024-10-20T05:02:40Z",
        fundId: "09849b2a-480d-49e6-a7aa-0ba1ae0bfe08",
        fundVehicleId: "4f057cb9-a73e-497e-8e36-ce73ea548b96",
      },
      {
        id: "c34fd7af-ad54-4176-849c-490f91b8ddf9",
        name: "Evergreen fund 2 template",
        isPublished: false,
        createdAt: "2025-05-14T06:32:45Z",
        fundId: "68f5f033-d175-42a4-8baa-910405ef1d5d",
        fundVehicleId: "b58b5052-a48b-46b6-973c-b3b0467ed149",
      },
      {
        id: "ec16d1a1-845a-4d87-9c6f-5575af5cfd06",
        name: "US strategy fund",
        isPublished: false,
        createdAt: "2025-03-05T04:50:07Z",
        fundId: "c6a3428c-a88c-4f0e-8137-218d892313ec",
        fundVehicleId: "ca760e96-b890-4643-bcdb-9a7b7bcf3508",
      },
      {
        id: "0384b1a5-030f-4624-8fb3-a763144ff769",
        name: "Equity fund",
        isPublished: true,
        createdAt: "2025-09-02T21:50:59Z",
        fundId: "48d92824-a682-4f0a-8c3b-c06293f939cd",
        fundVehicleId: "73c3f66b-c859-4c8d-9042-7be823ae73c1",
      },
      {
        id: "24ae46de-5ee2-4c67-afca-0a1bb37ca1e9",
        name: "FFX score measured fund",
        isPublished: true,
        createdAt: "2025-03-04T23:22:44Z",
        fundId: "536f750f-0a86-4f69-9542-bb615a3fe784",
        fundVehicleId: "798ef8c3-dd56-4906-bfca-5cdb226a6f02",
      },
    ],
  };

  return getGetSubscriptionTemplatesMockHandler(customProfileResponse);
};
